import { render } from "./ManualEventMailModal.vue?vue&type=template&id=377fcb5f&scoped=true&lang=pug"
import script from "./ManualEventMailModal.vue?vue&type=script&lang=js"
export * from "./ManualEventMailModal.vue?vue&type=script&lang=js"

import "./ManualEventMailModal.vue?vue&type=style&index=0&id=377fcb5f&scoped=true&lang=css"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377fcb5f"]])

export default __exports__